@if (showMenu()) {
  <header>
    @if (isInternal()) {
      <app-internal-nav-menu></app-internal-nav-menu>
    } @else {
      <app-external-nav-menu></app-external-nav-menu>
    }
  </header>
}


